/* Halftime — petites animations du mode Retro Gaming.
   · Choix de l'équipe : sur l'écran « Vous avez choisi … », un ballon en 3D (pixel) tourne au-dessus de la phrase
     et des confettis aux couleurs de l'équipe tombent.
   · Connexion au compte : à la première page vue après s'être connecté, le même ballon 3D rebondit avec
     « CONNEXION RÉUSSIE » (une fois par compte et par appareil).
   · Contrat signé (ajout au panier) : uniquement en mode rétro. Sur le site classique, c'est l'animation « BUT ! »
     (vestiaire-goal.js) qui reste ; le contrat y est donc retiré dès qu'il apparaît.
   · Fin de partie (tirs au but, La Lucarne, Cross Bar) : trois boutons, REJOUER · COMMANDER LA BOX · MENU PRINCIPAL.
   · Signature du contrat : « Halftime » écrit à la main (police Caveat), tracé puis encré.
   · Retrait d'un article (mode rétro) : écran VAR « VÉRIFICATION VAR… » puis « ACHAT ANNULÉ » (appelé par vestiaire-goal.js).
   · Fiche produit du mode rétro : toute la largeur de l'écran, photos du maillot à gauche, fiche, prix et description à droite,
     titre affiché une seule fois.
   · Menu (hamburger) : en mode rétro aussi, il ouvre le tiroir du site classique au lieu du menu du jeu.
   Aucune image à charger : tout est dessiné en code. Respecte « réduire les animations » du système. */
(function () {
  'use strict';
  if (window.HTFx) return;
  var H = document.documentElement;
  function retro() { return H.classList.contains('vj-retro'); }
  function calm() { return matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function el(t, c, h) { var e = document.createElement(t); if (c) e.className = c; if (h != null) e.innerHTML = h; return e; }
  function data() { try { return JSON.parse((document.getElementById('vja-data') || {}).textContent || '{}'); } catch (e) { return {}; } }

  /* ---------- ballon 3D : sphère ombrée + 12 pentagones placés sur les sommets d'un icosaèdre, en rotation ---------- */
  var PHI = (1 + Math.sqrt(5)) / 2, V = [];
  [[-1, PHI, 0], [1, PHI, 0], [-1, -PHI, 0], [1, -PHI, 0], [0, -1, PHI], [0, 1, PHI], [0, -1, -PHI], [0, 1, -PHI], [PHI, 0, -1], [PHI, 0, 1], [-PHI, 0, -1], [-PHI, 0, 1]].forEach(function (v) {
    var l = Math.hypot(v[0], v[1], v[2]); V.push([v[0] / l, v[1] / l, v[2] / l]);
  });
  function norm3(a) { var l = Math.hypot(a[0], a[1], a[2]) || 1; return [a[0] / l, a[1] / l, a[2] / l]; }
  function cross(a, b) { return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]]; }
  function rot(v, ax, ay) {
    var x = v[0], y = v[1], z = v[2], c = Math.cos(ay), s = Math.sin(ay);
    var x1 = x * c + z * s, z1 = -x * s + z * c; c = Math.cos(ax); s = Math.sin(ax);
    return [x1, y * c - z1 * s, y * s + z1 * c];
  }
  // dessine le ballon dans un petit canvas (rendu pixel, agrandi en CSS sans lissage)
  function ball(cv, opt) {
    opt = opt || {}; var N = cv.width = cv.height = opt.px || 40, x = cv.getContext('2d'), r = N / 2 - 2, t0 = performance.now(), live = true;
    function frame(now) {
      if (!live || !cv.isConnected) return;
      var t = (now - t0) / 1000, ay = t * 1.6, ax = .5 + Math.sin(t * .7) * .25;
      x.clearRect(0, 0, N, N);
      var g = x.createRadialGradient(N * .38, N * .34, r * .1, N / 2, N / 2, r);
      g.addColorStop(0, '#ffffff'); g.addColorStop(.7, '#dfe7ef'); g.addColorStop(1, '#8fa4b8');
      x.fillStyle = g; x.beginPath(); x.arc(N / 2, N / 2, r, 0, 7); x.fill();
      V.forEach(function (v0) {
        var v = rot(v0, ax, ay); if (v[2] < -.15) return;
        var up = Math.abs(v0[1]) > .9 ? [1, 0, 0] : [0, 1, 0], u = norm3(cross(v0, up)), w = cross(v0, u), pts = [];
        for (var k = 0; k < 5; k++) {
          var a = k * 2 * Math.PI / 5, p = norm3([v0[0] + .36 * (Math.cos(a) * u[0] + Math.sin(a) * w[0]), v0[1] + .36 * (Math.cos(a) * u[1] + Math.sin(a) * w[1]), v0[2] + .36 * (Math.cos(a) * u[2] + Math.sin(a) * w[2])]);
          p = rot(p, ax, ay); pts.push(p);
        }
        x.fillStyle = v[2] > .35 ? '#011636' : '#23466f'; x.beginPath();
        pts.forEach(function (p, i) { var X = N / 2 + p[0] * r, Y = N / 2 - p[1] * r; if (i) x.lineTo(X, Y); else x.moveTo(X, Y); });
        x.closePath(); x.fill();
      });
      x.strokeStyle = '#011636'; x.lineWidth = 1.5; x.beginPath(); x.arc(N / 2, N / 2, r, 0, 7); x.stroke();
      if (!calm()) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
    return function () { live = false; };
  }

  /* ---------- confettis pixel ---------- */
  function confetti(cols, ms) {
    if (calm()) return; var cv = el('canvas', 'htfx-conf'), x = cv.getContext('2d'), W = cv.width = innerWidth, Hh = cv.height = innerHeight, P = [];
    document.body.appendChild(cv);
    for (var i = 0; i < 120; i++) P.push({ x: Math.random() * W, y: -20 - Math.random() * Hh * .6, vx: (Math.random() - .5) * 2, vy: 2 + Math.random() * 3, c: cols[i % cols.length], s: 5 + (Math.random() * 4 | 0), r: Math.random() * 6 });
    var t0 = performance.now();
    (function f(t) {
      x.clearRect(0, 0, W, Hh);
      P.forEach(function (p) { p.x += p.vx + Math.sin((t + p.r * 300) / 300) * .8; p.y += p.vy; x.fillStyle = p.c; x.fillRect(Math.round(p.x), Math.round(p.y), p.s, p.s * (.5 + Math.abs(Math.sin(t / 200 + p.r)) * .5)); });
      if (t - t0 < (ms || 2600)) requestAnimationFrame(f); else cv.remove();
    })(t0);
  }

  /* ---------- couleurs d'une équipe à partir de son nom ---------- */
  function teamCols(name) {
    var g = ((window.HTED && HTED.GAME) || []).filter(function (r) { return r[0] === name; })[0];
    var c = g ? [g[2], g[3]] : (window.HTCOL && HTCOL.get(name));
    if (!c && window.HTED) { var n = (HTED.NATIONS || []).filter(function (r) { return r[0] === name; })[0]; if (n) c = [n[2], n[3]]; }
    c = c || ['#80adc6', '#023270'];
    return [c[0], c[1], '#ffffff', '#f5c518'];
  }

  /* ---------- 1. écran « Vous avez choisi … » ---------- */
  function decorateConf(box) {
    if (box.__fx) return; box.__fx = 1;
    var b = box.querySelector('b'), name = b ? b.textContent.trim() : '';
    var cv = el('canvas', 'htfx-ball big'); cv.setAttribute('aria-hidden', 'true'); box.insertBefore(cv, box.firstChild);
    ball(cv, { px: 48 });
    confetti(teamCols(name), 2400);
  }

  /* ---------- 2. connexion réussie ---------- */
  function welcome() {
    var d = data(); if (!d.customer || !retro()) return;
    var k = 'htfx:c', seen = null; try { seen = localStorage.getItem(k); } catch (e) {}
    if (seen === String(d.customer)) return;
    try { localStorage.setItem(k, String(d.customer)); } catch (e) {}
    var o = el('div', 'htfx-hello', '<canvas class="htfx-ball" aria-hidden="true"></canvas><b>CONNEXION RÉUSSIE</b><span>Tes records et trophées te suivent partout.</span>');
    o.setAttribute('role', 'status'); document.body.appendChild(o);
    ball(o.querySelector('canvas'), { px: 40 }); confetti(['#80adc6', '#ffffff', '#f5c518', '#023270'], 2200);
    o.addEventListener('click', function () { o.remove(); });
    setTimeout(function () { o.classList.add('out'); setTimeout(function () { o.remove(); }, 400); }, 2800);
  }

  /* ---------- 3. contrat signé : mode rétro uniquement, signature manuscrite simple ---------- */
  var FONT = 0;
  function font() {
    if (FONT) return; FONT = 1;
    var l = el('link'); l.rel = 'stylesheet'; l.href = 'https://fonts.googleapis.com/css2?family=Caveat:wght@600&display=swap'; document.head.appendChild(l);
  }
  function signGate(n) {
    if (!retro()) { n.remove(); return; }
    var old = n.querySelector('.htj-sig'); if (!old) return;
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('class', 'htj-sig htfx-sig'); s.setAttribute('viewBox', '0 0 320 90'); s.setAttribute('aria-label', 'Signé Halftime');
    s.innerHTML = '<text x="160" y="66" text-anchor="middle">Halftime</text>';
    old.parentNode.replaceChild(s, old);
    // on attend la police manuscrite pour que le tracé démarre sur les bonnes lettres
    if (document.fonts && document.fonts.load) document.fonts.load('600 60px Caveat').then(function () { s.classList.add('go'); }, function () { s.classList.add('go'); });
    else s.classList.add('go');
  }

  /* ---------- 5. retrait d'un article en mode rétro : écran VAR ---------- */
  function muted() { try { return JSON.parse(localStorage.getItem('vjg:settings') || '{}').sound === false; } catch (e) { return false; } }
  var AC = null;
  function beep(f, d, type) { if (muted()) return; try { AC = AC || new (window.AudioContext || window.webkitAudioContext)(); var o = AC.createOscillator(), g = AC.createGain(); o.type = type || 'square'; o.frequency.value = f; g.gain.value = .04; o.connect(g); g.connect(AC.destination); o.start(); g.gain.exponentialRampToValueAtTime(.0001, AC.currentTime + d); o.stop(AC.currentTime + d); } catch (e) {} }
  var varOn = 0;
  function varFx() {
    if (varOn) return; varOn = 1;
    var o = el('div', 'htfx-var', '<div class="htfx-tv"><p class="k">VAR</p><p class="chk">VÉRIFICATION VAR<i>…</i></p><p class="no">ACHAT ANNULÉ</p><small>Article retiré du panier</small></div>');
    o.setAttribute('role', 'status'); document.body.appendChild(o);
    beep(660, .08); setTimeout(function () { beep(660, .08); }, 300); setTimeout(function () { beep(660, .08); }, 600);
    setTimeout(function () { o.classList.add('dec'); beep(220, .35, 'sawtooth'); }, calm() ? 200 : 1100);
    o.addEventListener('click', function () { o.remove(); varOn = 0; });
    setTimeout(function () { o.classList.add('out'); setTimeout(function () { o.remove(); varOn = 0; }, 350); }, calm() ? 1600 : 2600);
  }
  window.HTRemoveFx = varFx;

  /* ---------- 4. fin de partie : REJOUER · COMMANDER LA BOX · MENU PRINCIPAL ---------- */
  var ROOT = (data().root || '/').replace(/\/?$/, '/'), BOX = ROOT + 'products/box-mystere';
  // menu principal : celui du jeu en mode rétro, l'écran de choix des mini-jeux sur le site classique
  function toMenu() {
    try { if (window.HTMini) HTMini.close(true); } catch (e) {}
    try { if (window.VJApp) VJApp.close(); } catch (e) {}
    setTimeout(function () { if (retro() && window.VJApp) VJApp.open(); else if (window.HTMini && HTMini.picker) HTMini.picker(); else location.href = ROOT; }, 380);
  }
  function menuBtn(cls) { var b = el('button', cls, '◀ MENU PRINCIPAL'); b.type = 'button'; b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toMenu(); }); return b; }
  // tirs au but : cartes « ÉLIMINÉ » et « VAINQUEUR » (elles avaient REJOUER + COMMANDER LA BOX)
  function cupCard(card) {
    if (card.__fx) return; card.__fx = 1;
    var first = card.querySelector('.vjc-btn'); if (!first) return;
    var row = first.parentNode;
    if (!row.querySelector('a[href*="box"]')) { var a = el('a', 'vjc-btn', '▶ COMMANDER LA BOX'); a.href = BOX; row.appendChild(a); }
    row.appendChild(menuBtn('vjc-btn')); row.classList.add('htfx-row');
  }
  // La Lucarne / Cross Bar : la carte de fin est dessinée dans le jeu, on ajoute la barre de boutons dessous
  function endBar(cv) {
    if (cv.__end || !cv.parentNode) return; cv.__end = 1;
    var b = el('div', 'htfx-end');
    var again = el('button', '', '↻ REJOUER'); again.type = 'button';
    var box = el('a', '', '▶ COMMANDER LA BOX'); box.href = BOX;
    b.appendChild(again); b.appendChild(box); b.appendChild(menuBtn(''));
    cv.parentNode.insertBefore(b, cv.nextSibling);
    function done() { b.remove(); setTimeout(function () { cv.__end = 0; }, 600); cv.removeEventListener('pointerdown', done); document.removeEventListener('keydown', key, true); }
    function key(e) { if (e.key === ' ' || e.key === 'Enter') done(); }
    again.addEventListener('click', function () { done(); try { cv.dispatchEvent(new PointerEvent('pointerdown', { bubbles: true, cancelable: true })); } catch (e) { cv.dispatchEvent(new MouseEvent('pointerdown', { bubbles: true })); } cv.focus(); });
    cv.addEventListener('pointerdown', done); document.addEventListener('keydown', key, true);
  }
  var FT = CanvasRenderingContext2D.prototype.fillText;
  CanvasRenderingContext2D.prototype.fillText = function (t) {
    var cv = this.canvas;
    if (cv && cv.classList && cv.classList.contains('mj8-cv') && !cv.__end && typeof t === 'string' && /^FIN D(E LA S|U D)/.test(t)) endBar(cv);
    return FT.apply(this, arguments);
  };

  /* ---------- 6. fiche produit du mode rétro : pleine largeur, titre une seule fois, description à droite ---------- */
  // Le titre de Dawn contient le nom deux fois (h1 + lien caché) : on ne garde que le h1, partout.
  function prodName() { var h = document.querySelector('.product__title h1'); return h ? h.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function kitFix() {
    var K = document.querySelector('.k32'); if (!K || !retro()) return;
    var name = prodName();
    // 1. l'écran prend toute la largeur de la page (il était enfermé dans la colonne d'infos de 820 px)
    var sec = K.closest('.shopify-section');
    if (sec && K.parentNode !== sec.parentNode) sec.parentNode.insertBefore(K, sec);
    // 2. titre une seule fois
    var t = K.querySelector('.k32-t'); if (t && name && t.textContent !== name) t.textContent = name;
    // la fiche joueur affiche le nom du joueur (ce qui suit l'année dans le titre), sans le doublon
    var b = K.querySelector('.vjfj-id b');
    if (b && name && !b.__fx) {
      var y = /((?:19|20)\d{2})(?:\s*[-\/]\s*((?:19|20)?\d{2}))?/.exec(name), rest = y ? name.slice(name.indexOf(y[0]) + y[0].length).trim() : '';
      if (rest) b.textContent = rest; b.__fx = 1;
    }
    // 3. description de l'article à droite, sous le prix
    var side = K.querySelector('.k32-side'), d = document.querySelector('.product__info-container .product__description');
    if (side && d && !side.querySelector('.htfx-desc')) {
      var box = el('section', 'htfx-desc', '<h3>DESCRIPTION</h3>'); box.appendChild(d.cloneNode(true)); side.appendChild(box);
    }
    H.classList.add('htfx-kit');
  }

  /* ---------- styles ---------- */
  var st = el('style');
  st.textContent =
    '.htfx-ball{display:block;width:96px;height:96px;image-rendering:pixelated;image-rendering:crisp-edges}' +
    '.hte-conf .htfx-ball.big{width:112px;height:112px;animation:htfxDrop .9s cubic-bezier(.3,1.6,.5,1) both,htfxHop 1.2s .9s ease-in-out infinite alternate;filter:drop-shadow(0 10px 0 rgba(0,0,0,.35))}' +
    '@keyframes htfxDrop{from{transform:translateY(-60vh)}}' +
    '@keyframes htfxHop{to{transform:translateY(-14px)}}' +
    '.htfx-conf{position:fixed;inset:0;z-index:2147483646;pointer-events:none}' +
    '.htfx-hello{position:fixed;left:50%;top:50%;z-index:2147483647;transform:translate(-50%,-50%);display:flex;flex-direction:column;align-items:center;gap:14px;padding:26px 30px;background:#011636;border:4px solid #80adc6;box-shadow:8px 8px 0 #000;color:#fff;text-align:center;cursor:pointer;animation:htfxPop .35s cubic-bezier(.2,1.5,.4,1)}' +
    '.htfx-hello .htfx-ball{animation:htfxHop .5s ease-in-out infinite alternate}' +
    '.htfx-hello b{font:400 clamp(12px,3vw,18px)/1.5 "Press Start 2P",monospace;color:#f5c518}' +
    '.htfx-hello span{font:400 13px/1.5 "Pixelify Sans","Press Start 2P",monospace;color:#dbe7ef;max-width:30ch}' +
    '.htfx-hello.out{opacity:0;transition:opacity .4s}' +
    '@keyframes htfxPop{from{transform:translate(-50%,-50%) scale(.6);opacity:0}}' +
    '.htfx-row{display:flex;flex-wrap:wrap;gap:10px;justify-content:center}' +
    '.htfx-end{display:flex;flex-wrap:wrap;gap:10px;justify-content:center;margin:14px auto 0;max-width:100%}' +
    '.htfx-end>*{all:unset;box-sizing:border-box;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;min-height:44px;padding:0 16px;font:400 11px/1 "Press Start 2P",monospace;background:#80adc6;color:#011636;border:3px solid #fff;box-shadow:4px 4px 0 #000;text-decoration:none}' +
    '.htfx-end>*:hover,.htfx-end>*:focus-visible{background:#fff;outline:none}' +
    '.htfx-end>:first-child{background:#f5c518}' +
    '@media (max-width:749px){.htfx-end>*{flex:1 1 100%}}' +
    '.htfx-sig{display:block;width:100%;height:70px;margin-top:6px;overflow:visible}' +
    '.htfx-sig text{font:600 58px Caveat,"Segoe Script","Bradley Hand",cursive;fill:transparent;stroke:#023270;stroke-width:1.2;stroke-dasharray:900;stroke-dashoffset:900}' +
    '.htfx-sig.go text{animation:htfxInk 1.4s .2s ease-out forwards,htfxFill .35s 1.4s forwards}' +
    '@keyframes htfxInk{to{stroke-dashoffset:0}}' +
    '@keyframes htfxFill{to{fill:#023270}}' +
    '.htfx-var{position:fixed;inset:0;z-index:2147483646;display:grid;place-items:center;padding:16px;background:rgba(1,22,54,.55);cursor:pointer}' +
    '.htfx-tv{box-sizing:border-box;width:min(360px,100%);padding:22px 18px;background:#000;border:6px solid #4b5866;box-shadow:8px 8px 0 #000,inset 0 0 40px rgba(128,173,198,.25);text-align:center;color:#fff;animation:htfxTv .3s steps(4)}' +
    '.htfx-tv p{margin:0}' +
    '.htfx-tv .k{display:inline-block;margin-bottom:12px;padding:5px 8px;background:#80adc6;color:#011636;font:400 10px/1 "Press Start 2P",monospace}' +
    '.htfx-tv .chk{font:400 clamp(10px,2.6vw,13px)/1.6 "Press Start 2P",monospace}' +
    '.htfx-tv .chk i{font-style:normal;animation:htfxBlink .5s steps(2) infinite}' +
    '.htfx-tv .no{display:none;font:400 clamp(14px,4vw,20px)/1.4 "Press Start 2P",monospace;color:#e5262d;text-shadow:3px 3px 0 #000}' +
    '.htfx-tv small{display:none;margin-top:10px;font:400 12px/1.4 "Pixelify Sans",monospace;color:#9fc0d6}' +
    '.htfx-var.dec .chk{display:none}.htfx-var.dec .no{display:block;animation:htfxStamp .3s cubic-bezier(.3,1.6,.5,1)}.htfx-var.dec small{display:block}' +
    '.htfx-var.out{opacity:0;transition:opacity .35s}' +
    '@keyframes htfxTv{from{transform:scaleY(.02);filter:brightness(3)}}' +
    '@keyframes htfxBlink{50%{opacity:0}}' +
    '@keyframes htfxStamp{from{transform:scale(1.8);opacity:0}}' +
    "html.vj-retro.htfx-kit .product__info-container .product__description{display:none!important}" +
    "html.vj-retro.htfx-kit .k32-head{align-items:flex-start;text-align:left}" +
    "html.vj-retro.htfx-kit .k32-t{text-align:left}" +
    "@media (min-width:990px){html.vj-retro.htfx-kit .k32-main{grid-template-columns:minmax(0,1.45fr) minmax(380px,1fr);gap:32px}html.vj-retro.htfx-kit .k32-stage{min-height:max(560px,calc(100vh - 260px))}}" +
    ".htfx-desc{padding:18px;background:linear-gradient(180deg,rgba(255,255,255,.10),rgba(255,255,255,.02) 40%,rgba(0,0,0,.25)),rgba(1,22,54,.7);box-shadow:inset 0 0 0 2px rgba(128,173,198,.35);color:#dbe7ef}" +
    ".htfx-desc h3{margin:0 0 10px;font:400 11px/1.4 \"Press Start 2P\",monospace;color:#80adc6}" +
    ".htfx-desc .product__description{margin:0;font:400 15px/1.6 \"Pixelify Sans\",system-ui,sans-serif;color:#dbe7ef}" +
    ".htfx-desc .product__description p{margin:0 0 .5em}" +
    ".htfx-desc .product__description *{color:inherit!important;font-family:inherit!important}" +
    '@media (prefers-reduced-motion:reduce){.htfx-ball,.htfx-hello,.htfx-tv,.htfx-var .no{animation:none!important}.htfx-sig text{animation:none!important;stroke-dashoffset:0;fill:#023270}}';
  (document.head || H).appendChild(st);

  /* ---------- 7. hamburger : le tiroir du site classique, aussi en mode rétro ----------
     Le code du mode rétro détourne le clic vers le menu du jeu, sauf si le bouton porte déjà la marque __vja :
     on la pose avant lui (ce script passe avant le démarrage du mode rétro), le tiroir de Dawn fonctionne donc normalement. */
  function keepDrawer() { var s = document.querySelector('header-drawer summary') || document.querySelector('.header__icon--menu'); if (s) s.__vja = 1; }
  keepDrawer();

  /* ---------- branchements ---------- */
  new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) {
      var n = ms[i].addedNodes[j]; if (n.nodeType !== 1) continue;
      if (n.classList.contains('htj-sign')) signGate(n);
      if (n.classList.contains('vjc-card') && (n.classList.contains('lose') || n.classList.contains('champ'))) cupCard(n);
      if (n.classList.contains('k32') || n.classList.contains('vjfj') || (n.querySelector && n.querySelector('.k32, .vjfj'))) kitFix();
      var c = n.classList.contains('hte-conf') ? n : n.querySelector && n.querySelector('.hte-conf'); if (c) decorateConf(c);
    }
  }).observe(H, { childList: true, subtree: true });
  function boot() { keepDrawer(); setTimeout(welcome, 900); kitFix(); setTimeout(kitFix, 1200); if (retro()) font(); new MutationObserver(function () { if (retro()) font(); }).observe(H, { attributes: true, attributeFilter: ['class'] }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.HTFx = { ball: ball, confetti: confetti };
})();
